export default [
    {
        name: 'Webmasters',
        path: '/webmasters',
        meta: {uiType: 'Overlay',},
        alias: [ '/webmaster', ],
        component: () => import(/* webpackChunkName: "Webmasters" */ '@/assets/js/src/modules/webmasters/_views/Webmasters.vue'),
    },
]
